const config = {
  global: {
    cookieCardLabels: [
      'name',
      'source',
      'purpose',
      'duration',
      'additionalInfo'
    ]
  }
};

export default config;
